const getters = {
  sidebar: state => state.app.sidebar,
  avatar: state => state.user.avatar,
}
export default getters
